export const API_BASE = import.meta.env.VITE_API_BASE ?? 'https://skipper-api.ghwmelite.workers.dev';
export const STORE_NAME = import.meta.env.VITE_STORE_NAME ?? 'Skipper CleanCare';
